import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import axios from 'axios';
import logger from '@/utils/logger';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fadeIn = { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true } };
const fadeInUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };
const halfSec = { duration: 0.5 };
const delayedHalfSec = { duration: 0.5, delay: 0.1 };

function FAQSidebar() {
  return (
    <div className="lg:col-span-4">
      <motion.p {...fadeIn} className="font-body text-xs uppercase tracking-[0.2em] text-zinc-400 mb-3">FAQ</motion.p>
      <motion.h2 {...fadeInUp} transition={halfSec} className="font-heading text-3xl sm:text-4xl font-black tracking-tight uppercase mb-4">Common Questions</motion.h2>
      <motion.p {...fadeInUp} transition={delayedHalfSec} className="font-body text-sm text-zinc-500 leading-relaxed">
        Can&apos;t find what you&apos;re looking for? Call us at (615) 961-5930 and we&apos;ll be happy to help.
      </motion.p>
    </div>
  );
}

function FAQList({ faqs }) {
  return (
    <div className="lg:col-span-8">
      <Accordion type="single" collapsible className="w-full">
        {faqs.map((faq, i) => (
          <AccordionItem key={faq.id} value={faq.id} className="border-black" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="font-heading text-sm font-bold uppercase tracking-tight text-left py-6 hover:no-underline hover:text-yellow-600 transition-colors">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="font-body text-sm text-zinc-600 leading-relaxed pb-6">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}

export default function FAQSection() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const res = await axios.get(`${API}/faq`);
        setFaqs(res.data);
      } catch (err) {
        logger.error('FAQ fetch failed:', err);
      }
    };
    fetchFaqs();
  }, []);

  if (!faqs.length) return null;

  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <FAQSidebar />
          <FAQList faqs={faqs} />
        </div>
      </div>
    </section>
  );
}
